<template>
  <div class="d-flex flex-column align-stretch backgrounded" style="height: 100%">
    <div>
      Welcome to Referra!
    </div>

    <div v-if="lead">
      {{ lead.account.account_name }}<br>sent you a lead.
    </div>

    <div>
      Join our app and get work from this business and others in your area.
    </div>

    <div class="rounded-lg mx-6 pa-4" style="background-color: #163F4F;">
      FREE for 30 days, no credit card required.
    </div>

    <div>
      Collect as many leads as you want during your trial with no commitment.
    </div>

    <div class="d-flex flex-column justify-center">
      <div>
        <v-btn color="primary" @click="nextClick">Try 30 Days Free</v-btn>
      </div>
    </div>
  </div>

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: "WizardStepA",

  props: ['claim_token'],

  data: () => ({
    lead: null,
  }),

  methods: {
    ...mapActions('wizard', ['loadUnclaimedPro', 'updateWizardState']),

    nextClick() {
      this.$router.replace( { name: 'wizardB' } )
    },
  },

  async created() {
    const result = await this.loadUnclaimedPro(this.claim_token)
    if(result.ok && result.accountClaimed) {
      this.$router.replace({ name: 'home' })
    }
    if (result.ok) {
      this.lead = result.mostRecentLead
    }
  }
}
</script>

<style scoped>
  div.backgrounded {
    background-color: black;
    background-image: url('/img/wizard/pro-welcome-bg-750x970.png');
    background-position-x: center;
    background-size: auto 100%;
  }

  div.backgrounded > div {
    color: white;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 30px;
    padding-left: 16px;
    padding-right: 16px;
    text-align: center;
  }
</style>
